import { render } from "./Warranties.vue?vue&type=template&id=b78d9bf6"
import script from "./Warranties.vue?vue&type=script&lang=js"
export * from "./Warranties.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__